<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    okTitle: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      title: '',
    }
  },

  created() {
    this.title = this.$t('confirmation')

    if (!this.message) {
      this.message = this.$t('areYouSure')
    }
  },

  computed: {
    showModal: {
      get() {
        return this.modal
      },

      set(newVal) {
        this.$emit('update:modal', newVal)
      },
    },
  },
}
</script>

<template>
  <b-modal
    centered
    v-model="showModal"
    :title="title"
    @ok="$emit('confirmed')"
    @cancel="$emit('cancelled')"
    :ok-title="$t('global.yes')"
    :cancel-title="$t('global.cancel')"
    :ok-only="false"
    size="md"
  >
    <div v-html="message" />
    <template #modal-footer="{ ok, cancel }">
      <b-row class="mc-modal__filter-footer">
        <b-col sm="12" md="4" class="mc-modal__filter-footer-fav"> </b-col>
        <b-col sm="12" md="8" class="mc-modal__filter-footer-btn">
          <b-button variant="outline-primary" class="me-3" @click="cancel()">
            {{ $t('global.cancel') }}
          </b-button>
          <b-button variant="primary" @click="ok()">
            {{ okTitle || $t('global.save') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
